/**
 * Do not edit directly, this file was auto-generated.
 */

export const BreakpointMobile = "320";
export const BreakpointMobileXl = "480";
export const BreakpointTablet = "481";
export const BreakpointTabletXl = "768";
export const BreakpointLaptop = "769";
export const BreakpointLaptopXl = "1024";
export const BreakpointDesktop = "1025";
export const BreakpointDesktopXl = "1200";
export const BreakpointTv = "1201";
export const ColorDarkBg100 = "#1C1C1E";
export const ColorDarkBg80 = "#3C3C3F";
export const ColorDarkBg60 = "#646467";
export const ColorDarkBg40 = "#A0A0A3";
export const ColorDarkBg20 = "#DCDCDF";
export const ColorDarkBlack100 = "#1C1C1E";
export const ColorDarkBlack80 = "#3C3C3F";
export const ColorDarkBlack60 = "#646467";
export const ColorDarkBlack40 = "#A0A0A3";
export const ColorDarkBlack20 = "#DCDCDF";
export const ColorDarkContrast100 = "#FFFAFC";
export const ColorDarkContrast80 = "#F6DFE9";
export const ColorDarkContrast60 = "#CAC4D0";
export const ColorDarkContrast40 = "#EDCBDA";
export const ColorDarkContrast20 = "#E3B6CB";
export const ColorDarkError = "#DC5252";
export const ColorDarkInfo = "#68A7CE";
export const ColorDarkPrimary = "#E8628D";
export const ColorDarkSecondary = "#78B69B";
export const ColorDarkTertiary = "#F9C2D6";
export const ColorDarkSuccess = "#70BC8E";
export const ColorDarkWarning = "#FFD666";
export const ColorDarkWhite100 = "#FFFAFC";
export const ColorDarkWhite80 = "#F6DFE9";
export const ColorDarkWhite60 = "#CAC4D0";
export const ColorDarkWhite40 = "#EDCBDA";
export const ColorDarkWhite20 = "#E3B6CB";
export const ColorLightBg100 = "#FFFAFC";
export const ColorLightBg80 = "#F6DFE9";
export const ColorLightBg60 = "#CAC4D0";
export const ColorLightBg40 = "#EDCBDA";
export const ColorLightBg20 = "#E3B6CB";
export const ColorLightBlack100 = "#1C1C1E";
export const ColorLightBlack80 = "#3C3C3F";
export const ColorLightBlack60 = "#646467";
export const ColorLightBlack40 = "#A0A0A3";
export const ColorLightBlack20 = "#DCDCDF";
export const ColorLightContrast100 = "#1C1C1E";
export const ColorLightContrast80 = "#3C3C3F";
export const ColorLightContrast60 = "#646467";
export const ColorLightContrast40 = "#A0A0A3";
export const ColorLightContrast20 = "#DCDCDF";
export const ColorLightError = "#DC5252";
export const ColorLightInfo = "#68A7CE";
export const ColorLightPrimary = "#E8628D";
export const ColorLightSecondary = "#78B69B";
export const ColorLightTertiary = "#F9C2D6";
export const ColorLightSuccess = "#70BC8E";
export const ColorLightWarning = "#FFD666";
export const ColorLightWhite100 = "#FFFAFC";
export const ColorLightWhite80 = "#F6DFE9";
export const ColorLightWhite60 = "#CAC4D0";
export const ColorLightWhite40 = "#EDCBDA";
export const ColorLightWhite20 = "#E3B6CB";
